(() => {
  const nav = document.querySelector('[data-nra-catnav]');
  if (!nav) return;

  const items = Array.from(nav.querySelectorAll('.nra-catnav__item--has-drop'));

  const closeAll = (except) => {
    items.forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-nra-catnav-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  const openItem = (item) => {
    closeAll(item);
    item.classList.add('is-open');
    const trigger = item.querySelector('[data-nra-catnav-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  };

  const toggleItem = (item) => {
    if (item.classList.contains('is-open')) {
      closeAll();
    } else {
      openItem(item);
    }
  };

  items.forEach((item) => {
    const trigger = item.querySelector('[data-nra-catnav-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleItem(item);
    });
  });

  document.addEventListener('click', (event) => {
    if (!nav.contains(event.target)) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
